import { useState } from "react";
import useWexClient from "./Clients/wexClient,";

const useRegions = () => {
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(null);

  const {
    getRegionDetail,
  } = useWexClient();

  const handleRequest = async (
    callback,
    defaultMessage,
  ) => {
    setLoader(true);
    setError(null);

    try {
      const response = await callback();

      return response;
    } catch (err) {
      console.error(defaultMessage, err);

      const errorMessage =
        err?.response?.data?.message ||
        err?.message ||
        defaultMessage;

      setError(errorMessage);

      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    } finally {
      setLoader(false);
    }
  };

  /**
   * Obtener detalle de región
   */
  const getRegionById = async (regionId) => {
    return handleRequest(
      () => getRegionDetail(regionId),
      "Error al obtener detalle de región",
    );
  };

  return {
    getRegionById,
    loader,
    error,
  };
};

export default useRegions;